"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiListInput = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var multi_list_chooser_1 = require("../../modules/multi.list.chooser/multi.list.chooser");
var multi_list_chooser_style_1 = require("../../modules/multi.list.chooser/multi.list.chooser.style");
var nested_list_chooser_state_1 = require("../../modules/multi.list.chooser/nested.list.chooser.state");
var select_list_chooser_state_1 = require("../../modules/multi.list.chooser/select.list.chooser.state");
var services_1 = require("../../services");
var render_service_1 = require("../../services/render.service");
var icon_1 = require("../icon");
var icons_1 = require("../icon/icons");
var modal_service_1 = require("../modal/modal.service");
var theme_1 = require("../theme");
var nested_list_input_style_1 = require("./nested.list.input.style");
(0, theme_1.addStyles)(nested_list_input_style_1.Style);
exports.MultiListInput = {
    view: function (state) {
        var color = null;
        if (
        // If we have the correct token
        services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG)
            // And the state is one of the correct types
            && (state instanceof select_list_chooser_state_1.SelectListChooserState || state instanceof nested_list_chooser_state_1.NestedListChooserState)
            // And the state's field is the one marked as the color field
            && state.field.collection.schema.metadata.mapColorFieldId === state.field.schema.id) {
            color = state.field.color;
        }
        var children = [(0, render_service_1.m)('span', { className: nested_list_input_style_1.CSS.label }, state.displayValue)];
        if (color) {
            children.push((0, render_service_1.m)('div', { className: nested_list_input_style_1.CSS.colorIndicator, style: { backgroundColor: color } }));
        }
        children.push(icon_1.Icon.view(icons_1.MaterialIcon.FILTER_NONE, { className: nested_list_input_style_1.CSS.edit }));
        return (0, render_service_1.m)('div', { className: nested_list_input_style_1.CSS.container }, [
            (0, render_service_1.m)('button', { className: "".concat(nested_list_input_style_1.CSS.button, " mdl-button"), onclick: function (e) { return exports.MultiListInput.viewModal(e.target, state); } }, children)
        ]);
    },
    viewModal: function (element, state) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var oldValue, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (modal_service_1.ModalService.isOpen) {
                            return [2 /*return*/, null];
                        }
                        state.setFocused(true);
                        oldValue = state.value != null ? state.value.slice() : null;
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: multi_list_chooser_1.MultiListChooserTitle.view(state),
                                content: function () { return multi_list_chooser_1.MultiListChooserContent.view(state); },
                                className: multi_list_chooser_style_1.CSS.modal,
                                hasCancel: true
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.ok && state.value == null) {
                            // Assign default value
                            state.selectDefaultValue();
                        }
                        else if (!result.ok) {
                            state.setValue(oldValue);
                        }
                        state.setFocused(false);
                        element.focus();
                        return [2 /*return*/];
                }
            });
        });
    }
};
//# sourceMappingURL=multi.list.input.js.map